import { render } from "./NewBadge.vue?vue&type=template&id=2e1d937a"
import script from "./NewBadge.vue?vue&type=script&lang=js"
export * from "./NewBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/NewBadge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e1d937a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e1d937a', __exports__)) {
    api.reload('2e1d937a', __exports__)
  }
  
  module.hot.accept("./NewBadge.vue?vue&type=template&id=2e1d937a", () => {
    api.rerender('2e1d937a', render)
  })

}


export default __exports__